import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { LanguageEditComponent } from '../language-edit/language-edit.component';
import { LanguageService, Language } from '../../services/language.service';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.css']
})
export class LanguageComponent implements OnInit {

  public languages: Language[];
  public isLoading = false;

  constructor(
    public dialog: MatDialog,
    private languageSvc: LanguageService
  ) { }

  ngOnInit() {
    this.loadLanguages();
  }

  private loadLanguages() {
    console.log("LOADING LANGUAGES");
    this.isLoading = true;
      this.languageSvc.loadLanguages().then(
        (data) => {
          this.languages = data;
          console.log("Languages:", this.languages);

      this.isLoading = false;
        }
      ).catch((err) => {
        alert("Error while getting the languages"); //TODO this is temp
        console.log(err);

        this.isLoading = false;
      });
  }

  public addLanguage() {
    const dialogRef = this.dialog.open(LanguageEditComponent, {
      //data: serviceDate,
    });
  }

  public editLanguage(lang) {
    console.log(lang);
    const dialogRef = this.dialog.open(LanguageEditComponent, {
      //data: serviceDate,
    });
  }

  public deleteLanguage(lang) {
     alert("Delete language");
  }

}
